import { render, staticRenderFns } from "./SpeechBubble.vue?vue&type=template&id=dc7675e4&scoped=true"
import script from "./SpeechBubble.vue?vue&type=script&lang=js"
export * from "./SpeechBubble.vue?vue&type=script&lang=js"
import style0 from "./SpeechBubble.vue?vue&type=style&index=0&id=dc7675e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7675e4",
  null
  
)

export default component.exports